import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


function UnstyledList({ listItems, className, listItemClassName }) {
    return (
        <ul className={classNames('rh-list-style-type-none rh-pl-0', className)}>
            <For
                each="item"
                of={listItems}
            >
                <li
                    className={classNames(listItemClassName)}
                    key={item.key}
                >
                    {item.message}
                </li>
            </For>
        </ul>
    );
}

UnstyledList.propTypes = ({
    listItems: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.any.isRequired,
        message: PropTypes.node,
    })).isRequired,
    className: PropTypes.string,
    listItemClassName: PropTypes.string,
});

UnstyledList.defaultProps = {
    className: undefined,
    listItemClassName: undefined,
};


export default UnstyledList;
